import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpRequestErrorHandler, HttpUtils, RequestResponse} from "@rbaip/ui-component";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EquipmentComponentizationService {

  constructor(private http: HttpClient) {
  }

  public componentizeEquipment(equipIds: number[]): Observable<RequestResponse> {
    const url = `/api/equipment/componentization`;
    const body = JSON.stringify(equipIds);
    return this.http.post<RequestResponse>(url, body, HttpUtils.jsonHttpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('Componentize Equipment', null))
      );
  }

  public decomponentizeEquipment(equipId: number): Observable<RequestResponse> {
    const url = `/api/equipment/${equipId}/decomponentization`;
    return this.http.post<RequestResponse>(url, null, HttpUtils.jsonHttpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('Componentize Equipment', null))
      );
  }
}
